import { CommonStatusUILabel, FormatLabelFn } from '@@partner:types:app'
import { WORKSHIFT } from '@hive/status'



export const formatWorkshiftStatusLabel: FormatLabelFn = (value) => {
  const foundStatus = SHIFT_STATUSES.find(s => s.value === value) ?? { label: 'Неизвестный статус', color: 'red' }

  return {
    label: foundStatus.label,
    color: foundStatus.color
  } as CommonStatusUILabel
}

export const SHIFT_STATUSES = [
  { label: 'Запланирована', value: WORKSHIFT.INITIAL, color: 'blue' },
  { label: 'На смене', value:  WORKSHIFT.STARTED, color: 'green' },
  { label: 'Завершена', value: WORKSHIFT.FINISHED, color: undefined },
  { label: 'Отменена', value: -1, color: 'red' },
  { label: 'Ожидает подтверждения', value: WORKSHIFT.WAITING_CONFIRMATION, color: 'yellow' },
  { label: 'Отменена', value: WORKSHIFT.CANCELED, color: undefined }
]